module.exports = __webpack_public_path__ + "static/media/AHR EXPO Logo.f80deacf.jpeg";